import React from 'react';
import PropTypes from 'prop-types';

// Import Local Styles
import styles from './box-wrapper.css';

const BoxWrapper = (props) => {
    const { children, modifier } = props;

    return (
        <section className={`${styles.wrapper} ${modifier || ''}`}>
            {children}
        </section>
    );
};

BoxWrapper.propTypes = {
    children: PropTypes.node,
    modifier: PropTypes.string
};

export default BoxWrapper;
